import React from 'react';
import _ from 'lodash';

import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {convertValueToDollar} from 'common/utils';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {BudgetUtils} from 'app-ui-componentlibrary/dist/go/components/common/BudgetUtils';

/*
 * DFLT_DOLLAR_VALUE is being used as the default for lodash gets of dollar values.
 * The BudgetSummaryTableWithSubProgramFunding component goes hand-in-hand with
 * the BudgetSummaryListener using a groupBy: byNamedFieldPath attribute
 * The BudgetUtils.computeBudgetSummaryByNamedFieldPath(...) should every dollar
 * value needed even for an object with all 0's for values of the named field
 * not used in application,  e.g.
 * "Some Value Not Used By app": { SHSP: 0, UASI: 0, OPSG: 0, total: 0}
 * If the DFLT_DOLLAR_VALUE is getting displayed for your app in a place where
 * some other value is expected, double check config file.  Make sure entire
 * set of values are listed in the BudgetSummaryListener configuration, and those
 * values match the keys for itemConfig attribute of this component. E.g., if one
 * of the listener's fieldValueList elements is "SomeValueInList" then that should appear
 * in the "itemConfig": { "SomeValueInList": {"label": "Some value in list", "order", 1}, ...}
 * of this component's configuration
 * Debated on whether to use -1 value to make this situation more "visible"
 */
const DFLT_DOLLAR_VALUE = 0;
export class BudgetSummaryTableWithSubProgramFunding extends React.Component {
  constructor(props) {
    super(props);
  }

  getSelectedItems = (itemConfig) => {
    let {fundingStreams, itemFieldPath} = this.props;
    let items = BudgetUtils.collectItemsContainingFieldPath([], itemFieldPath, fundingStreams);
    let itemValues = _.map(items, (item) => _.get(item, itemFieldPath)).sort();
    let newConfigItem = _.cloneDeep(itemConfig);
    let finalItem = _.pick(newConfigItem, itemValues);

    return finalItem;
  }

  renderTableHeader = (groupByFieldName, groupByTotalName) => {
    let {includeSubProgramFunding} = this.props;
    if (!includeSubProgramFunding) {
      return (
        <FemaGoTable.Row>
          <FemaGoTable.HeaderCell>{groupByFieldName}</FemaGoTable.HeaderCell>
          <FemaGoTable.HeaderCell type="number">
            {groupByTotalName}
          </FemaGoTable.HeaderCell>
        </FemaGoTable.Row>
      );
    } else {
      return (
        <FemaGoTable.Row>
          <FemaGoTable.HeaderCell>{groupByFieldName}</FemaGoTable.HeaderCell>
          <FemaGoTable.HeaderCell textAlign="right">SHSP</FemaGoTable.HeaderCell>
          <FemaGoTable.HeaderCell textAlign="right">UASI</FemaGoTable.HeaderCell>
          <FemaGoTable.HeaderCell textAlign="right">OPSG</FemaGoTable.HeaderCell>
          <FemaGoTable.HeaderCell type="number">
            {groupByTotalName}
          </FemaGoTable.HeaderCell>
        </FemaGoTable.Row>
      );
    }
  };

  renderTableBodyRow = (item, key, groupByValues) => {
    let {includeSubProgramFunding, uasiSubProgramOnly} = this.props;
    const rowValues = _.get(groupByValues, key, {});
    if (!includeSubProgramFunding) {
      if (uasiSubProgramOnly) {
        return (
          <FemaGoTable.Row key={item.label}>
            <FemaGoTable.TextCell>{item.label}</FemaGoTable.TextCell>
            <FemaGoTable.NumberCell>
              {convertValueToDollar(_.get(rowValues, 'UASI', DFLT_DOLLAR_VALUE))}
            </FemaGoTable.NumberCell>
          </FemaGoTable.Row>
        );
      }
      else {
        return (
          <FemaGoTable.Row key={item.label}>
            <FemaGoTable.TextCell>{item.label}</FemaGoTable.TextCell>
            <FemaGoTable.NumberCell>
              {convertValueToDollar(_.get(rowValues, 'total', DFLT_DOLLAR_VALUE))}
            </FemaGoTable.NumberCell>
          </FemaGoTable.Row>
        );
      }
    } else {
      return (
        <FemaGoTable.Row key={item.label}>
          <FemaGoTable.TextCell>{item.label}</FemaGoTable.TextCell>
          <FemaGoTable.NumberCell>
            {convertValueToDollar(_.get(rowValues, 'SHSP', DFLT_DOLLAR_VALUE))}
          </FemaGoTable.NumberCell>
          <FemaGoTable.NumberCell>
            {convertValueToDollar(_.get(rowValues, 'UASI', DFLT_DOLLAR_VALUE))}
          </FemaGoTable.NumberCell>
          <FemaGoTable.NumberCell>
            {convertValueToDollar(_.get(rowValues, 'OPSG', DFLT_DOLLAR_VALUE))}
          </FemaGoTable.NumberCell>
          <FemaGoTable.NumberCell>
            {convertValueToDollar(_.get(rowValues, 'total', DFLT_DOLLAR_VALUE))}
          </FemaGoTable.NumberCell>
        </FemaGoTable.Row>
      );
    }
  };

  renderTableFooter = (totalValues) => {
    let {includeSubProgramFunding, uasiSubProgramOnly} = this.props;
    if (!includeSubProgramFunding) {
      if (uasiSubProgramOnly) {
        return (
          <FemaGoTable.Row>
            <FemaGoTable.TextCell>
              <strong>Total</strong>
            </FemaGoTable.TextCell>
            <FemaGoTable.NumberCell>
              <strong>
                {convertValueToDollar(_.get(totalValues, 'UASI', DFLT_DOLLAR_VALUE))}
              </strong>
            </FemaGoTable.NumberCell>
          </FemaGoTable.Row>
        );
      }
      else {
        return (
          <FemaGoTable.Row>
            <FemaGoTable.TextCell>
              <strong>Total</strong>
            </FemaGoTable.TextCell>
            <FemaGoTable.NumberCell>
              <strong>
                {convertValueToDollar(_.get(totalValues, 'total', DFLT_DOLLAR_VALUE))}
              </strong>
            </FemaGoTable.NumberCell>
          </FemaGoTable.Row>
        );
      }
    } else {
      return (
        <FemaGoTable.Row>
          <FemaGoTable.TextCell>
            <strong>SubProgram Total</strong>
          </FemaGoTable.TextCell>
          <FemaGoTable.NumberCell>
            <strong>
              {convertValueToDollar(_.get(totalValues, 'SHSP', DFLT_DOLLAR_VALUE))}
            </strong>
          </FemaGoTable.NumberCell>
          <FemaGoTable.NumberCell>
            <strong>
              {convertValueToDollar(_.get(totalValues, 'UASI', DFLT_DOLLAR_VALUE))}
            </strong>
          </FemaGoTable.NumberCell>
          <FemaGoTable.NumberCell>
            <strong>
              {convertValueToDollar(_.get(totalValues, 'OPSG', DFLT_DOLLAR_VALUE))}
            </strong>
          </FemaGoTable.NumberCell>
          <FemaGoTable.NumberCell>
            <strong>
              {convertValueToDollar(_.get(totalValues, 'total', DFLT_DOLLAR_VALUE))}
            </strong>
          </FemaGoTable.NumberCell>
        </FemaGoTable.Row>
      );
    }
  };

  render() {
    let {
      budgetSummaryData,
      groupByFieldName,
      groupByTotalName,
      itemConfig,
      summary,
      fundingStreams,
      itemFieldPath
    } = this.props;

    let finalItemConfig = fundingStreams && itemFieldPath ? this.getSelectedItems(itemConfig) : itemConfig;
    if (_.get(budgetSummaryData, 'groupByValues')) {
      return (
        <React.Fragment>
          <FemaGoTable summary={summary || 'Group by budget summary table'}>
            <FemaGoTable.Header>
              {this.renderTableHeader(groupByFieldName, groupByTotalName)}
            </FemaGoTable.Header>
            <FemaGoTable.Body>
              {_.map(finalItemConfig, (item, key) =>
                this.renderTableBodyRow(item, key, budgetSummaryData.groupByValues)
              )}
              {this.renderTableFooter(budgetSummaryData.totalValues)}
            </FemaGoTable.Body>
          </FemaGoTable>
          <br /> <br />{' '}
          {/* added to "lift" last national summary table above the minimized Review Panel*/}
        </React.Fragment>
      );
    } else {
      return null;
    }
  }
}

export default connectDynamic(BudgetSummaryTableWithSubProgramFunding);
